import {
  LOADING_UI,
  STOP_LOADING_UI,
  CLEAR_ERRORS,
  INCREMENT_REFRESH,
  SET_ERRORS,
  SET_PAGE,
  SET_DOCUMENT_FROM_REDUX,
  SET_DOCUMENT_FROM_DB,
  SET_LAST_VISIBLE_DOCUMENT,
  SET_DOCUMENTS,
  PAGINATE_DOCUMENTS,
  STORE_DOCUMENT,
  CREATE_DOCUMENT,
  MODIFY_DOCUMENT,
  REMOVE_DOCUMENT,
  LOADING_DOCUMENT,
  STOP_LOADING_DOCUMENT,
  SET_DOCUMENT_NOT_FOUND,
  CLEAR_IMAGES,
  CLEAR_TEXTBOXES,
  CLEAR_SKETCH,
} from '../types'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import axios from 'axios'
import { storage } from '../../config/fbConfig'
//Utils
import { embedImageAndText } from '../../utilities/fileReader/SigningHandler'
import { handleError } from '../../utilities/errorHandler/errorHandler'

toast.configure()

export const setPage = (state) => {
  return {
    type: SET_PAGE,
    payload: state,
  }
}

export const getReadyDocument = (docId) => (dispatch) => {
  dispatch({ type: CLEAR_ERRORS })
  dispatch({ type: LOADING_DOCUMENT })
  dispatch({
    type: SET_DOCUMENT_FROM_REDUX,
    payload: docId,
  })
}

export const getDirectDocument = (docId) => {
  return async (dispatch, getState, { getFirebase, getFirestore }) => {
    const firestore = getFirestore()
    dispatch({ type: CLEAR_ERRORS })
    dispatch({ type: LOADING_DOCUMENT })
    firestore
      .collection('Documents')
      .doc(docId)
      .get()
      .then((doc) => {
        if (doc.exists) {
          const document = { id: docId, ...doc.data() }
          dispatch({
            type: SET_DOCUMENT_FROM_DB,
            payload: document,
          })
        } else {
          dispatch({
            type: SET_DOCUMENT_NOT_FOUND,
          })
        }
      })
      .catch((error) => {
        handleError(error, dispatch, toast, SET_ERRORS)
        dispatch({
          type: SET_DOCUMENT_FROM_DB,
          payload: null,
        })
      })
  }
}

export const getPendingDocuments = () => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firestore = getFirestore()
    dispatch({ type: CLEAR_ERRORS })
    dispatch({ type: LOADING_DOCUMENT })
    const userId = getState().user.credentials.id
    firestore
      .collection('Documents')
      .where('participants', 'array-contains', userId)
      .where('status', '==', 'Pending')
      .get()
      .then((querySnapshot) => {
        const documents = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }))
        dispatch({
          type: SET_DOCUMENTS,
          payload: documents,
        })
      })
      .catch((error) => {
        handleError(error, dispatch, toast, SET_ERRORS)
        dispatch({
          type: SET_DOCUMENTS,
          payload: [],
        })
      })
  }
}

export const getDocuments = (status, limit, forceGet = true) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firestore = getFirestore()
    dispatch({ type: CLEAR_ERRORS })
    // dispatch({ type: LOADING_DOCUMENT })
    const order = status === 'Pending' ? 'createdAt' : 'endedAt'
    const userId = getState().user.credentials.id
    const docRef = firestore
      .collection('Documents')
      .where('participants', 'array-contains', userId)
      .where('status', '==', status)
      .orderBy(order, 'desc')
      .limit(limit)

    if (forceGet && getState().document.lastVisibleDocument[status].doc) {
      // already start paginate
      docRef
        .startAfter(getState().document.lastVisibleDocument[status].doc)
        .get()
        .then((querySnapshot) => {
          const documents = querySnapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }))
          dispatch({
            type: PAGINATE_DOCUMENTS,
            payload: documents,
          })
          var lastVisible = querySnapshot.docs[querySnapshot.docs.length - 1]
          dispatch({
            type: SET_LAST_VISIBLE_DOCUMENT,
            payload: {
              status,
              data: {
                ...(lastVisible && { doc: lastVisible }),
                ...(!lastVisible && { isRear: true }),
              },
            },
          })
        })
        .catch((error) => {
          handleError(error, dispatch, toast, SET_ERRORS)
          dispatch({
            type: PAGINATE_DOCUMENTS,
            payload: [],
          })
        })
    } else if (!getState().document.lastVisibleDocument[status].doc) {
      // about to start paginate
      docRef
        .get()
        .then((querySnapshot) => {
          const documents = querySnapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }))

          dispatch({
            type: PAGINATE_DOCUMENTS,
            payload: documents,
          })
          var lastVisible = querySnapshot.docs[querySnapshot.docs.length - 1]
          dispatch({
            type: SET_LAST_VISIBLE_DOCUMENT,
            payload: {
              status,
              data: {
                ...(lastVisible && { doc: lastVisible }),
                ...(!lastVisible && { isRear: true }),
              },
            },
          })
        })
        .catch((error) => {
          handleError(error, dispatch, toast, SET_ERRORS)
          dispatch({
            type: PAGINATE_DOCUMENTS,
            payload: [],
          })
        })
    }
  }
}

export const rejectDocument = ({ documentId, rejectReason, rejecterName }) => {
  return async (dispatch, getState, { getFirebase, getFirestore }) => {
    dispatch({ type: CLEAR_ERRORS })
    dispatch({ type: LOADING_UI })
    try {
      const response = await axios.post('https://us-central1-usm-sign.cloudfunctions.net/rejectDocument', {
        id: documentId,
        rejectReason,
        rejecterName,
      })
      console.log({ response })
      toast.success('Document Rejected Successfully', { autoClose: 2500, position: 'bottom-right' })
      dispatch({ type: STOP_LOADING_UI })
    } catch (error) {
      dispatch({ type: STOP_LOADING_UI })
      handleError(error, dispatch, toast, SET_ERRORS)
    }
  }
}

export const createDocument = (document, file, history) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firestore = getFirestore()
    let newDocument = {}
    dispatch({ type: CLEAR_ERRORS })
    dispatch({ type: LOADING_UI })
    const originalFileName = file.name
    storeDocument(file, originalFileName, 'original', dispatch)
      .then((obj) => {
        newDocument = {
          ...document,
          editableDoc: null,
          signedDoc: null,
          originalDoc: { url: obj.url, name: obj.formattedName },
          documentName: obj.originalName,
          createdAt: new Date().toISOString(),
          endedAt: null,
        }
        firestore
          .collection('Documents')
          .add({ ...newDocument })
          .then((data) => {
            dispatch({ type: STOP_LOADING_UI })
            toast.success('Document Created Successfully', { autoClose: 2500, position: 'bottom-right' })
            dispatch({
              type: CREATE_DOCUMENT,
              payload: {
                id: data.id,
                ...newDocument,
              },
            })
            history.push(`/viewDocumentDetails/${data.id}`)
          })
          .catch((error) => {
            dispatch({ type: STOP_LOADING_UI })
            handleError(error, dispatch, toast, SET_ERRORS)
          })
      })
      .catch((error) => {
        dispatch({ type: STOP_LOADING_UI })
        handleError(error, dispatch, toast, SET_ERRORS)
      })
  }
}

export const addRealTimeDocument = (docId, docStatus, senderId) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firestore = getFirestore()
    let document = getState().document
    if (docStatus !== 'Pending') {
      if (document.documents.findIndex((doc) => doc.id === docId && doc.status !== docStatus) > -1) {
        dispatch({
          type: REMOVE_DOCUMENT,
          payload: docId,
        })
        dispatch({ type: INCREMENT_REFRESH })
      }
    }

    if (docStatus === 'Pending' || document.lastVisibleDocument[docStatus].doc) {
      // if it is not null anymore, means pagination started
      let index2 = document.documents.findIndex((doc) => doc.id === docId)
      if (index2 === -1) {
        // document is not in the redux, means new document
        firestore
          .collection('Documents')
          .doc(docId)
          .get()
          .then((doc) => {
            if (doc.exists) {
              const document = { id: doc.id, ...doc.data() }
              dispatch({
                type: CREATE_DOCUMENT,
                payload: document,
              })
            }
          })
          .catch((error) => {
            handleError(error, dispatch, toast, SET_ERRORS)
          })
      } else {
        //document in redux
        if (document.documents[index2].status !== docStatus) {
          // console.log('exisitng document with new status/changed status')
          dispatch(updateRealtimeDocument(docId, docStatus))
        }
      }
    } else if (document.document && document.document.id === docId) {
      dispatch(updateRealtimeDocument(docId, docStatus))
    }
  }
}

export const updateRealtimeDocument = (docId, docStatus) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firestore = getFirestore()
    let myDocument = getState().document
    if (docStatus !== 'Pending') {
      //do work for status other than Pending only
      if (myDocument.lastVisibleDocument[docStatus].doc || (myDocument.document && myDocument.document.id === docId)) {
        // update document in redux
        if (myDocument.document && myDocument.document.id === docId) {
          //reload the page if the user is currently viewing the doc
          dispatch({ type: LOADING_DOCUMENT })
        }
        firestore
          .collection('Documents')
          .doc(docId)
          .get()
          .then((doc) => {
            if (doc.exists) {
              const document = { id: docId, ...doc.data() }
              let index = myDocument.documents.findIndex((doc) => doc.id === docId && doc.status === docStatus)
              if (index !== -1 || myDocument.lastVisibleDocument[docStatus].doc) {
                //found in the redux
                dispatch({
                  type: MODIFY_DOCUMENT,
                  payload: document,
                })
              } else {
                //not found in redux, means exisitng doc with new status
                dispatch({
                  type: REMOVE_DOCUMENT,
                  payload: docId,
                })
                if (myDocument.document && myDocument.document.id === docId) {
                  dispatch({
                    type: SET_DOCUMENT_FROM_DB,
                    payload: document,
                  })
                }
              }

              dispatch({ type: INCREMENT_REFRESH })
            } else {
              dispatch({ type: STOP_LOADING_DOCUMENT })
            }
          })
          .catch((error) => {
            dispatch({ type: STOP_LOADING_DOCUMENT })
            handleError(error, dispatch, toast, SET_ERRORS)
          })
      } else {
        // delete outdated doc in redux
        dispatch({
          type: REMOVE_DOCUMENT,
          payload: docId,
        })
        dispatch({ type: INCREMENT_REFRESH })
      }
    } else {
      dispatch({ type: STOP_LOADING_DOCUMENT })
    }
  }
}

export const signDocument = (document, signerId, signerName, images, textboxes, history) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firebase = getFirebase()
    dispatch({ type: LOADING_UI })

    signingTransaction(firebase, dispatch, document, signerId, signerName, images, textboxes)
      .then(async (obj) => {
        toast.success('Signed Document Successfully', { autoClose: 2500, position: 'bottom-right' })
        history.push('/viewDocumentDetails/' + document.id)

        dispatch({ type: STOP_LOADING_UI })
        dispatch({
          type: MODIFY_DOCUMENT,
          payload: {
            ...document,
            ...obj.modifiedData,
          },
        })

        dispatch({ type: CLEAR_IMAGES })
        dispatch({ type: CLEAR_TEXTBOXES })
        dispatch({ type: CLEAR_SKETCH })
        try {
          await firebase
            .firestore()
            .collection('Notifications')
            .doc(document.id)
            .update({
              receivers: firebase.firestore.FieldValue.arrayRemove(signerId),
            })

          //delete previous unneeded document
          if (!obj.isOriginal) {
            await storage.ref('documents/editable').child(obj.name).delete()
            // console.log(`${obj.name} is deleted`)
          }

          if (obj.isAllSigned) {
            const response = await axios.post('https://us-central1-usm-sign.cloudfunctions.net/digitallySignDocument', {
              id: document.id,
            })
            console.log({ response })
          }
        } catch (error) {
          console.log(error)
        }
      })

      .catch(function (error) {
        dispatch({ type: STOP_LOADING_UI })
        handleError(error, dispatch, toast, SET_ERRORS)
      })
  }
}

const signingTransaction = async (firebase, dispatch, document, signerId, signerName, images, textboxes) => {
  var docRef = firebase.firestore().collection('Documents').doc(document.id)
  return firebase.firestore().runTransaction(async function (transaction) {
    return transaction.get(docRef).then(async function (sfDoc) {
      if (!sfDoc.exists) {
        const error = 'Document does not exist!'
        dispatch({ type: STOP_LOADING_UI })
        toast.error(error, { autoClose: 2500, position: 'bottom-right' })
        dispatch({
          type: SET_ERRORS,
          payload: error,
        })
        throw new Error(error)
      }
      let isOriginal
      let target
      let editedDoc
      let storedDoc
      let editable = sfDoc.data().editableDoc
      const totalSignature = sfDoc.data().totalSignature + 1
      const totalReceivers = sfDoc.data().totalReceivers
      const isAllSigned = totalReceivers === totalSignature
      const receivers = sfDoc.data().receivers
      const updatedReceivers = receivers.map((receiver) =>
        receiver.id === signerId
          ? {
              id: receiver.id,
              name: signerName,
              signedAt: new Date().toISOString(),
            }
          : receiver
      )

      if (editable === null) {
        isOriginal = true
        target = sfDoc.data().originalDoc.url
      } else {
        isOriginal = false
        target = sfDoc.data().editableDoc.url
      }
      try {
        editedDoc = await embedImageAndText(target, images, textboxes)
        storedDoc = await storeDocument(editedDoc, sfDoc.data().documentName, 'editable', dispatch)
      } catch (error) {
        console.log(error)
      }

      let modifiedData = {
        editableDoc: {
          name: storedDoc.formattedName,
          url: storedDoc.url,
        },
        totalSignature: totalSignature,
        receivers: updatedReceivers,
      }
      transaction.update(docRef, modifiedData)
      return {
        isOriginal,
        ...(editable && { name: editable.name }),
        isAllSigned,
        modifiedData,
      }
    })
  })
}

const storeDocument = (document, originalName, type, dispatch) => {
  return new Promise((resolve, reject) => {
    let uploadTask
    const formattedName = Date.now() + '-' + originalName
    const storageRef = storage.ref(`documents/${type}/${formattedName}`)

    if (type === 'original') {
      Object.defineProperty(document, 'name', {
        writable: true,
        value: formattedName,
      }) // change the name of document to newly formatted name
      uploadTask = storageRef.put(document)
    } else {
      uploadTask = storageRef.putString(document, 'data_url')
    }
    uploadTask.on(
      'state_changed',
      (snapshot) => {},
      (error) => {
        reject(error)
      },
      () => {
        storage
          .ref(`documents/${type}`)
          .child(formattedName)
          .getDownloadURL()
          .then((url) => {
            let storedDoc = { url, originalName, formattedName }

            dispatch({
              type: STORE_DOCUMENT,
              payload: storedDoc,
            })
            resolve(storedDoc)
          })
          .catch((error) => {
            dispatch({ type: STOP_LOADING_UI })
            handleError(error, dispatch, toast, SET_ERRORS)
          })
      }
    )
  })
}
